import React from 'react'
import '../assets/animate/animate.css';
import '../assets/css/style.css';
import { FaBuilding } from 'react-icons/fa';

import { MdConstruction } from 'react-icons/md';
import { MdContactSupport } from "react-icons/md";

function Features() {
  return (
   
            <div className="feature wow fadeInUp" data-wow-delay="0.1s">
                
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-md-12">
                            <div className="feature-item">
                                
                                <MdConstruction size={80} style={{ color:"#ff8800" }} />
                                
                                <div className="feature-text">
                                    <h3>Expert Worker</h3>
                                    <p>Trained construction workers ensuring safety, strength, and timely project completion.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="feature-item">
                            <FaBuilding size={40}/>
                                <div className="feature-text">
                                    <h3>Quality Work</h3>
                                    <p>Superior quality guaranteed with expert workers and proven construction standards.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="feature-item">
                                
                            <MdContactSupport size={80} style={{color:"#ff8800"}}/>
                                
                                <div className="feature-text">
                                    <h3>24/7 Support</h3>
                                    <p>Dedicated support team available anytime for your construction project needs.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
  )
}

export default Features
